<script lang="ts" setup>
import EmptyManIcon from "~/assets/icons/empty-images/null-man.svg?url";
import EmptyWomanIcon from "~/assets/icons/empty-images/null-woman.svg?url";
import useAccountStore from '~/shared/store/modules/account';
import phoneFormatter from "~/composables/phone-formatter";

const accountStore = useAccountStore();

const manager = computed(() => accountStore.userProfile?.manager);

const emptyPhoto = manager.value?.sex == 'male' ? EmptyManIcon : EmptyWomanIcon;

</script>

<template>
  <div
    v-if="manager"
    class="account-manager"
  >
    <div class="account-manager__photo-wrapper">
      <img
        class="account-manager__photo"
        :src="manager.avatar || emptyPhoto"
      />
    </div>
    <div class="account-manager__info-wrapper">
      <span class="account-manager__info-name">{{ manager.lastName }} {{ manager.firstName}}</span>
      <span class="account-manager__info-phone">{{ phoneFormatter(manager.phone) }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.account {
  &-manager {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    &__info {
      &-name {
        @include font(14px, 20px, 500);
      }
      &-phone {
        @include font(14px, 20px);
      }
      &-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
    }
    &__photo {
      width: 100%;
      height: 100%;
      object-fit: cover;
      &-wrapper {
        width: 48px;
        height: 48px;
        border-radius: 100%;
        overflow: hidden;
      }
    }
  }
}
</style>
